var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "-3.58 0 65.54 65.54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6,
    transform: "translate(-294.563 -265.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    d: "M331.753,274.075v-3.95a4.328,4.328,0,0,0-4.32-4.32h-7.36a4.328,4.328,0,0,0-4.32,4.32v3.95a29.19,29.19,0,1,0,16,0Zm-12-3.95a.322.322,0,0,1,.32-.32h7.36a.322.322,0,0,1,.32.32v3.11a28.712,28.712,0,0,0-8,0Zm4,57.22a25.194,25.194,0,1,1,25.19-25.19A25.218,25.218,0,0,1,323.753,327.345Z",
    fill: "#1f1930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    d: "M347.073,301.955a23.335,23.335,0,0,0-23.12-23.13,1.274,1.274,0,0,0-.2-.01,1.476,1.476,0,0,0-.21.01,23.335,23.335,0,0,0-23.12,23.13,2,2,0,0,0,0,.4,23.333,23.333,0,0,0,23.12,23.12,1.48,1.48,0,0,0,.21.01,1.278,1.278,0,0,0,.2-.01,23.333,23.333,0,0,0,23.12-23.12,2,2,0,0,0,0-.4Zm-4.15,2.2h.06a19.379,19.379,0,0,1-17.24,17.23,1.992,1.992,0,0,0-3.98,0,19.39,19.39,0,0,1-17.25-17.24,2,2,0,0,0,0-3.98,19.391,19.391,0,0,1,17.25-17.25,2,2,0,0,0,3.98,0,19.38,19.38,0,0,1,17.24,17.24h-.06a2,2,0,0,0,0,4Z",
    fill: "#192753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    d: "M333.3,292.605a2.022,2.022,0,0,0-1.97-.51l-12.58,3.62a1.965,1.965,0,0,0-.76.39,1.213,1.213,0,0,0-.17.15,1.632,1.632,0,0,0-.17.2c-.05.07-.1.14-.14.21s-.08.16-.12.24a1.457,1.457,0,0,0-.07.19l-3.63,12.64a2.006,2.006,0,0,0,1.92,2.55,2.163,2.163,0,0,0,.56-.08l12.58-3.62.05-.01c.1-.03.2-.07.3-.11.06-.03.12-.07.18-.1.07-.05.14-.09.21-.15a1.54,1.54,0,0,0,.19-.17,1.684,1.684,0,0,0,.18-.21,2.268,2.268,0,0,0,.13-.2,2,2,0,0,0,.19-.48l3.63-12.58A2.016,2.016,0,0,0,333.3,292.605Zm-4.34,4.34-1.69,5.89-4.21-4.2Zm-10.43,10.42,1.7-5.9,4.2,4.2Z",
    fill: "#192753"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassIcon);
export default __webpack_public_path__ + "static/media/compassIcon.9b2ef616ef8de66f7be6ce44b9918d9c.svg";
export { ForwardRef as ReactComponent };